<template>
  <q-page padding>
    <PageHeader
      :title="pageTitle"
      :backRoute="backRouteConfig"
      backBehavior="route"
    />
    <div
      v-if="!$route.params.reservaId"
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold"
    >
      <div class="input-new-design col-md-2 col-xs">
        <div class="titulo-input">Unidade</div>
        <ListaUnidadesSelect />
      </div>
      <div v-if="temPermissaoCracha()" class="input-new-design col-md-2 col-xs">
        <div class="texto-titulo-select">Crachá Solicitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          dense
          outlined
          v-model="crachaSolicitante"
          @emitirFuncionario="receberFuncionarioPorCracha"
          :atualizarDados="atualizarDadosUsuario"
          :resetar="resetarFuncionario"
          debounce="500"
          :buscarPorCracha="true"
        />
      </div>
      <div class="input-new-design col-md-2 col-xs">
        <div class="titulo-input">Nome do Requisitante</div>
        <SelecaoFuncionario
          class="input-new-design"
          @emitirFuncionario="receberFuncionario"
          :atualizarDados="atualizarDadosUsuario"
          :resetar="resetarFuncionario"
        />
      </div>
    </div>
    <div
      v-else
      class="row col-12 q-mt-md q-gutter-sm text-brand-5 text-weight-bold"
    >
      <div class="col-md-2 col-xs-6">
        <div class="titulo-input">Unidade</div>
        <q-input
          v-model="dadosReserva.unidade"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="titulo-input">Nº Reserva</div>
        <q-input
          v-model="dadosReserva.numeroReserva"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="titulo-input">Nome Solicitante</div>
        <q-input
          v-model="dadosReserva.solicitante"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-5">
        <div class="titulo-input">Data de Criação</div>
        <q-input
          v-model="dadosReserva.criadoEm"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
      <div class="col-md-2 col-xs-6">
        <div class="titulo-input">Matricula Solicitante</div>
        <q-input
          v-model="dadosReserva.matricula"
          dense
          outlined
          disable
          class="input"
          bg-color="brand-7"
        />
      </div>
    </div>

    <span
      v-if="mensagemAtrasado"
      @click="confirm = true"
      style="
        background-color: #eebf00;
        padding: 18px 0px;
        margin-top: 21px;
        margin-bottom: 22px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #21324a;
        cursor: pointer;
        text-align: center;
      "
      >O funcionário possui ferramentas que excederam o tempo de permanência,
      por isso os itens abaixo em cinza estão bloqueados até a devolução ser
      realizada. Clique aqui para visualizar os itens que estão travando as
      novas retiradas.</span
    >
    <div>
      <div class="row col-12 items-center q-mb-sm">
        <div
          style="
            font-size: 16px;
            display: block;

            color: #21324a;
          "
          class="row col-12 q-mb-sm"
          :class="{ 'q-mt-lg': !mensagemAtrasado }"
        >
          Selecione as Ferramentas que Deseja Retirar
        </div>
        <div class="row col-12">
          <ComponenteFiltros
            :codigo="true"
            :classCodigo="'col-md col-xs-6'"
            :descricao="true"
            :classDescricao="'col-md col-xs-5'"
            :patrimonio="true"
            :classPatrimonio="'col-md col-xs-6'"
            :classGrupo="'col-md col-xs-5'"
            :subgrupo="true"
            :classSubgrupo="'col-md col-xs-6'"
            @enviarFiltro="receberFiltro"
          />
        </div>
      </div>
      <q-linear-progress v-if="loading" indeterminate size="3px" />
      <q-table
        :columns="columns"
        :rows="
          $route.params.reservaId ? ativosSelecionadoReserva : listaFerramenta
        "
        :hideBottom="
          !listaFerramenta.length == 0 || ativosSelecionadoReserva.length > 0
        "
        dense
        selection="multiple"
        :class="{ 'my-sticky-dynamic': !mobile }"
        v-model:selected="selected"
        :rows-per-page-options="[0]"
        flat
        :filter="filtros.nome"
        row-key="ativoUuid"
        @request="handleRequest"
        binary-state-sort
        v-model:pagination="pagination"
        :grid="mobile"
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:item="props">
          <q-card
            class="container-grid-table row col-12 q-mt-sm"
            :style="
              props.selected
                ? 'transform: scale(0.98); background: #b7cdf6'
                : ''
            "
            @click="
              autenticacao
                ? quasar.notify({
                    message:
                      'Não é possivel remover ou selecionar novos ativos depois de criar a retirada.',
                    color: 'negative',
                    actions: [
                      {
                        label: 'Fechar',
                        color: 'white',
                        handler: () => {
                          /* ... */
                        },
                      },
                    ],
                  })
                : (props.selected = !props.selected)
            "
          >
            <div class="row col-12 items-center q-pa-sm">
              <div class="col-8">
                <div class="row col-12">
                  <span style="word-break: break-all"
                    ><strong>Código: </strong
                    >{{ props.row.catalogoItem?.codigo }}</span
                  >
                </div>
                <div class="row col-12">
                  <span style="word-break: break-all"
                    ><strong>Descrição: </strong
                    >{{ props.row.catalogoItem?.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span><strong>Preço: </strong>{{ props.row.preco }}</span>
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Patrimônio: </strong
                    >{{ props.row.patrimonio }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Grupo: </strong
                    >{{ props.row.catalogoItem?.catalogoGrupo.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <span
                    ><strong>Subgrupo: </strong
                    >{{ props.row.catalogoItem?.catalogoSubGrupo.nome }}</span
                  >
                </div>
                <div class="row col-12">
                  <div
                    v-if="props.row?.atributos?.length > 0"
                    class="row col-12"
                  >
                    <span class="q-mr-sm"
                      ><strong>Chave: </strong
                      >{{ props.row?.atributos[0].chave }}</span
                    >
                    <span
                      ><strong>Valor: </strong>{{ props.row?.atributos[0].valor
                      }}<span v-if="props.row?.atributos?.length > 1"
                        >....</span
                      ></span
                    >
                    <q-tooltip v-if="props.row?.atributos?.length > 1">
                      <div
                        v-for="(atributo, index) in props.row.atributos"
                        :key="index"
                      >
                        <div class="row col-12" v-if="atributo.valor">
                          <div class="row col-12 justify-between">
                            <span class="q-mr-sm"
                              >Chave: {{ atributo.chave }}
                            </span>
                            <span>Valor: {{ atributo.valor }}</span>
                          </div>
                        </div>
                      </div>
                    </q-tooltip>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="row col-12 justify-end items-center">
                  <div class="q-mr-sm">
                    <div
                      style="
                        border: 1px solid #707070;
                        height: 60px;
                        width: 60px;
                        border-radius: 5px;
                        background-color: white;
                      "
                      class="items-center row col justify-center"
                    >
                      <q-img
                        v-if="props.row.urlImagem"
                        fit="contain"
                        height="100%"
                        width="95%"
                        :src="props.row.urlImagem"
                      />
                      <q-img
                        v-else
                        fit="contain"
                        height="100%"
                        width="95%"
                        src="../../../assets/semImagem.jpg"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </q-card>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th v-for="col in props.cols" :key="col.name" :props="props">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr class="text-brand-5 text-weight-bold">
            <q-td class="coluna-selecionar">
              <q-btn
                round
                size="10px"
                :icon="props.selected ? 'close' : 'add'"
                :color="
                  props.selected
                    ? 'red'
                    : props.row.bloqueio == 1
                    ? 'grey'
                    : 'secondary'
                "
                @click="props.selected = !props.selected"
                :disable="autenticacao || props.row.bloqueio == 1"
              />
            </q-td>
            <q-td>{{ props.row?.codigo }} {{ props.row.bloqueio }}</q-td>
            <q-td>{{ props.row.descricao }}</q-td>
            <q-td>{{ props.row.valor }}</q-td>
            <q-td>{{ props.row.patrimonio }}</q-td>
            <q-td>{{ props.row.grupo?.nome }}</q-td>
            <q-td>{{ props.row.subgrupo?.nome }}</q-td>
            <q-td>
              <div v-if="props.row.documentosVinculados?.length > 0">
                <span :class="{ 'text-red': props.row.vencido }">
                  {{ props.row.documentosVinculados?.length }}
                </span>
                <q-tooltip>
                  <div
                    v-for="(documento, index) in props.row.documentosVinculados"
                    :key="index"
                  >
                    <div>
                      <span class="row col-12">Nome: {{ documento.nome }}</span>
                      <div
                        :style="
                          documento.status == 'valido'
                            ? 'width: fit-content; padding: 0px 0px'
                            : documento.status == 'vencido'
                            ? 'width: fit-content; padding: 0px 5px'
                            : documento.status == 'revalidado'
                            ? 'width: fit-content; padding: 0px 5px'
                            : documento.status == 'inativo'
                            ? 'width: fit-content; padding: 0px 5px'
                            : ''
                        "
                        class="row col-12 items-center"
                      >
                        <div
                          v-if="documento.status == 'valido'"
                          class="elipse-table q-mr-xs bg-positive"
                        ></div>
                        <div
                          v-if="documento.status == 'revalidado'"
                          class="elipse-table q-mr-xs bg-warning"
                        ></div>
                        <div
                          v-if="documento.status == 'vencido'"
                          class="elipse-table q-mr-xs"
                          style="background: red"
                        ></div>
                        <div
                          v-if="documento.status == 'inativo'"
                          class="elipse-table q-mr-xs"
                          style="background: #383737"
                        ></div>
                        <span
                          v-if="documento.status != 'inativo'"
                          class="row justify-center text-white"
                        >
                          {{
                            `${documento.status
                              ?.substring(0, 1)
                              .toUpperCase()}${documento.status?.substring(1)}`
                          }}
                        </span>
                        <span
                          v-if="documento.status == 'inativo'"
                          class="row text-white justify-center"
                        >
                          Obsoleto
                        </span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else>0</div>
            </q-td>
            <q-td>
              <div v-if="props.row?.atributos?.length > 0">
                <div>
                  <span class="q-mr-xs"
                    >Chave: {{ props.row?.atributos[0].chave }}
                  </span>
                  <span> Valor: {{ props.row?.atributos[0].valor }}</span>
                  <span v-if="props.row?.atributos?.length > 1">....</span>
                </div>
                <q-tooltip v-if="props.row?.atributos?.length > 1">
                  <div
                    v-for="(atributo, index) in props.row.atributos"
                    :key="index"
                  >
                    <div class="row col-12" v-if="atributo.valor">
                      <div class="row col-12 justify-between">
                        <span class="q-mr-sm"
                          >Chave: {{ atributo.chave }}
                        </span>
                        <span> Valor: {{ atributo.valor }}</span>
                      </div>
                    </div>
                  </div>
                </q-tooltip>
              </div>
              <div v-else>
                <span>Sem Atributos</span>
              </div>
            </q-td>
            <q-td>
              <div
                :style="
                  props.row.status == 'disponivel'
                    ? 'width: fit-content; background: #e8ffec; padding: 2px 5px;'
                    : props.row.status == 'manutencao_garantia'
                    ? 'width: fit-content; background: #e6e6e6; padding: 2px 5px;'
                    : props.row.status == 'uso'
                    ? 'width: fit-content; background: #fefed1; padding: 2px 5px;'
                    : props.row.status == 'manutencao'
                    ? 'width: fit-content; background: #ffe9e9; padding: 2px 5px;'
                    : props.row.status == 'em_transito'
                    ? 'width: fit-content; background:  #f8f8f8; padding: 2px 5px;'
                    : props.row.status == 'removida'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status == 'retorno_em_garantia'
                    ? 'width: fit-content; background:  #9BA4B5; padding: 2px 5px;'
                    : props.row.status == 'desmobilizada'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : props.row.status == 'reativacao'
                    ? 'width: fit-content; background:  #5178FF; padding: 2px 5px;'
                    : props.row.status == 'descartada'
                    ? 'width: fit-content; background:  #EBEEFE; padding: 2px 5px;'
                    : props.row.status == 'sucata'
                    ? 'width: fit-content; background:  #F3E8E0; padding: 2px 5px;'
                    : props.row.status == 'furto'
                    ? 'width: fit-content; background:  #AB1D22; padding: 2px 5px;'
                    : props.row.status == 'aguardando_reparo'
                    ? 'width: fit-content; background:  #EDBC5A; padding: 2px 5px;'
                    : ''
                "
                class="row col-12 no-wrap align items-center"
              >
                <span
                  v-if="props.row.status == 'disponivel'"
                  class="elipse q-mr-sm bg-positive"
                ></span>
                <span
                  v-if="props.row.status == 'uso'"
                  class="elipse q-mr-sm bg-warning"
                ></span>
                <span
                  v-if="props.row.status == 'manutencao_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #424242"
                ></span>
                <span
                  v-if="props.row.status == 'manutencao'"
                  class="elipse q-mr-sm bg-red"
                ></span>
                <span
                  v-if="props.row.status == 'em_transito'"
                  class="elipse q-mr-sm"
                  style="background: #2d3e6e"
                ></span>
                <span
                  v-if="props.row.status == 'removida'"
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status == 'retorno_em_garantia'"
                  class="elipse q-mr-sm"
                  style="background: #383737"
                ></span>
                <span
                  v-if="props.row.status == 'desmobilizada'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <span
                  v-if="props.row.status == 'reativacao'"
                  class="elipse q-mr-sm"
                  style="background: #473fe8"
                ></span>
                <span
                  v-if="props.row.status == 'descartada'"
                  class="elipse q-mr-sm"
                  style="background: #b0cde8"
                ></span>
                <span
                  v-if="props.row.status == 'sucata'"
                  class="elipse q-mr-sm"
                  style="background: #736d6a"
                ></span>
                <span
                  v-if="props.row.status == 'furto'"
                  class="elipse q-mr-sm"
                  style="background: #6b1215"
                ></span>
                <span
                  v-if="props.row.status == 'aguardando_reparo'"
                  class="elipse q-mr-sm"
                  style="background: #fa9726"
                ></span>
                <div
                  v-if="props.row.status == 'disponivel'"
                  style="width: fit-content; background: #e8ffec"
                  class="text-brand-5 text-bold"
                >
                  {{ "Disponível" }}
                </div>
                <div
                  v-if="props.row.status == 'uso'"
                  style="width: fit-content; background: #fefed1"
                  class="text-brand-5 text-bold"
                >
                  {{ "Em Uso" }}
                </div>
                <div
                  v-if="props.row.status == 'manutencao_garantia'"
                  style="width: fit-content"
                  class="text-brand-5 text-bold"
                >
                  {{ "Manutenção Garantia" }}
                </div>
                <div
                  v-if="props.row.status == 'manutencao'"
                  style="width: fit-content"
                  class="text-red text-bold"
                >
                  {{ "Manutenção" }}
                </div>
                <div
                  v-if="props.row.status == 'em_transito'"
                  style="width: fit-content; color: #192957"
                  class="text-bold"
                >
                  {{ "Em Trânsito" }}
                </div>
                <div
                  v-if="props.row.status == 'removida'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Removida" }}
                </div>
                <div
                  v-if="props.row.status == 'retorno_em_garantia'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Retorno Em Garantia" }}
                </div>
                <div
                  v-if="props.row.status == 'desmobilizada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Desmobilizada" }}
                </div>
                <div
                  v-if="props.row.status == 'reativacao'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Reativação" }}
                </div>
                <div
                  v-if="props.row.status == 'descartada'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Descartada" }}
                </div>
                <div
                  v-if="props.row.status == 'sucata'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Sucata" }}
                </div>
                <div
                  v-if="props.row.status == 'furto'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Furto" }}
                </div>
                <div
                  v-if="props.row.status == 'aguardando_reparo'"
                  style="width: fit-content"
                  class="text-bold"
                >
                  {{ "Aguardando Reparo" }}
                </div>
              </div>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div v-if="listaFerramenta.length > 0" class="row justify-center q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          :size="mobile ? 'md' : 'sm'"
        />
      </div>
    </div>
    <div class="q-mt-xl" v-if="selected.length > 0">
      <div class="row col-12 justify-between items-center">
        <div class="q-ml-md text-brand-5 text-weight-bold titulo-tabela">
          Resumo da Retirada
        </div>
      </div>
    </div>
    <ComponenteChecklistAcessorio
      :etapa="'emprestimo'"
      :tela="'retirada'"
      :verificar="validarRespostas"
      :arrayRespostas="selected"
      :respostas="respostas"
      :disable="autenticacao"
      :filtro="filtroSelecionado"
      :botaoRemover="true"
      :perguntas="true"
      @removerAtivo="removerFerramenta"
      @enviarValidacaoRespostas="criarRetirada"
    />
    <ComponenteAutenticacao
      :autenticacao="autenticacao"
      :usuario="dados.dadosRequisitante"
      :etapa="'emprestimo'"
      :resetar="resetarAutenticacao"
      :atualizarUserLogado="atualizarUserLogado"
      :desabilitarBotaoCriar="desabilitarBotaoCriar"
      :campoObservacao="true"
      @iniciarAutenticacao="verificarRespostas"
      @resetarAutenticacao="resetVariaveis"
      @enviarAutenticacaoSolicitante="receberAutenticacaoSolicitante"
      @enviarAutenticacaoAlmoxarife="receberAutenticacaoAlmoxarife"
      @atualizarTemplates="atualizarTemplatesBiometria"
      @finalizarProcesso="retirarFerramenta"
      @enviarSetupConfiguracao="receberSetupConfiguracao"
    />
    <dialog-info-design
      class="row col-12"
      :width="'2000px'"
      mensagem="Ferramentas que precisam ser devolvidas"
      subMensagem="Essas ferramentas ultrapassaram o tempo de permanência, por favor devolva as mesmas para conseguir realizar novas retiradas."
      :height="'340px'"
      :exibir="confirm"
      @resultado="confirm = false"
    >
      <q-table
        flat
        table-header-style="background-color: #d9effc"
        :rows="listaAtrasado"
        dense
        style="width: 1000px"
        class="tabela-tamanho-fixo"
        :columns="columnsModal"
        :loading="disable"
        hide-pagination
        v-model:pagination="pagination"
        :filter="filter"
        :rows-per-page-options="[0]"
        @request="handleRequest"
      >
        <template #body-cell-previsao="props">
          <q-td>
            {{ props.row.tempoPermanencia }}
          </q-td>
        </template>
        <template #body-cell-atrasoDias="props">
          <q-td>
            {{ props.row?.ativosAtrasados[0]?.diferencaEmDia }}
          </q-td>
        </template>
        <template #body-cell-atrasoHoras="props">
          <q-td v-if="props.row?.ativosAtrasados[0]?.diferencaEmHora">
            {{
              props.row?.ativosAtrasados[0]?.diferencaEmHora > 0
                ? `${Math.floor(
                    props.row?.ativosAtrasados[0]?.diferencaEmHora
                  )} (Hr)`
                : `${(
                    props.row?.ativosAtrasados[0]?.diferencaEmHora / 60
                  ).toFixed(1)} (Min)`
            }}
          </q-td>
        </template>
      </q-table>
    </dialog-info-design>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";

import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import DialogInfoDesign from "../components/DialogInfoDesign.vue";
import SelecaoFuncionario from "../components/SelecaoFuncionario.vue";
import ComponenteAutenticacao from "../components/ComponenteAutenticacao.vue";
import ComponenteChecklistAcessorio from "../components/ComponenteChecklistAcessorio.vue";
import ComponenteFiltros from "../components/ComponenteFiltros.vue";
import { useRoute } from "vue-router";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "codigo",
    sortable: true,
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
    field: "catalogoItemNome",
    sortable: true,
  },
  {
    name: "valor",
    label: "Preço",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
    sortable: true,
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
    sortable: true,
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
    sortable: true,
  },
  {
    name: "documentos",
    label: "Documentos",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
    sortable: true,
  },
];

const columns2 = [
  {
    name: "selecionar",
    label: "",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descrição",
    label: "Descrição",
    align: "left",
  },
  {
    name: "valor",
    label: "Valor",
    align: "left",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    align: "left",
  },
  {
    name: "grupo",
    label: "Grupo",
    align: "left",
  },
  {
    name: "subgrupo",
    label: "Subgrupo",
    align: "left",
  },
  {
    name: "atributo",
    label: "Atributos",
    align: "left",
  },
];

const columnsModal = [
  {
    name: "codigo",
    label: "Código",
    field: (row) => row.ativosAtrasados[0]?.ativo?.catalogoItem?.codigo,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "descricao",
    label: "Descrição",
    field: (row) => row.ativosAtrasados[0]?.ativo?.catalogoItem?.nome,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "patrimonio",
    label: "Patrimônio",
    field: (row) => row.ativosAtrasados[0]?.ativo?.patrimonio,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "origem",
    label: "Origem",
    field: (row) => row.ativosAtrasados[0]?.ativo?.origem,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "tempoPermanencia",
    label: "Tempo de Permanência",
    field: (row) => row.ativosAtrasados[0]?.ativo?.tempoPermanencia,
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "atrasoDias",
    label: "Atraso em Dias",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "atrasoHoras",
    label: "Atraso em Horas",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "dataRetirada",
    label: "Data de Retirada",
    field: (row) =>
      row.ativosAtrasados[0]?.retiradoEm
        ?.split(" ")[0]
        ?.split("-")
        ?.reverse()
        ?.join("/"),
    align: "left",
    style: "white-space: normal",
  },
];

export default {
  components: {
    ListaUnidadesSelect,
    SelecaoFuncionario,
    ComponenteAutenticacao,
    ComponenteChecklistAcessorio,
    ComponenteFiltros,
    DialogInfoDesign,
    PageHeader,
  },
  setup() {
    const store = useStore();
    const quasar = useQuasar();

    const listaFerramenta = ref([]);
    const dados = ref({
      metodoAutenticacao: "",
      dadosRequisitante: {
        id: "",
        idTabela: "",
        nome: "",
        matricula: "",
        biometria: "",
      },
    });
    const confirm = ref(false);
    const selected = ref([]);
    let autenticacao = ref(false);
    const base64 = ref(null);
    const salvarAssinatura = ref(0);
    let biometriaModal = ref(false);
    const filtroSelecionado = ref("");
    let usuarioVerificado = ref(false);
    const atualizarDadosUsuario = ref(0);
    const resetarFuncionario = ref(0);
    let disable = ref(false);
    const dadosReserva = ref({});
    const valorOrdenacao = ref("");
    const igual = ref(false);
    const ativosSelecionadoReserva = ref([]);
    const listaAtrasado = ref([]);
    const desabilitarBotaoCriar = ref(false);
    const mensagemAtrasado = ref(false);
    const avisoAtrasadoJaExibido = ref(false);
    const processandoSelecaoFuncionario = ref(false);
    let loading = ref(false);
    const filtros = ref({});
    const route = useRoute();

    const pageTitle = computed(() => {
      if (route.params.reservaId) {
        return `Retirada de Ferramentas - Reserva: #${dadosReserva.value.numeroReserva}`;
      }
      return "Retirada de Ferramentas";
    });

    const backRouteConfig = computed(() => {
      if (route.params.reservaId) {
        return {
          name: "ferramentaria-detalhe-reserva",
          params: { reservaId: route.params.reservaId },
        };
      }
      return { name: "home" }; // ou qual for a rota pai
    });
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 6,
    });
    let fazerAutenticacao = ref(0);
    const resetarAutenticacao = ref(0);
    const autenticacaoSolicitante = ref({
      authType: "",
      authContent: "",
    });
    const autenticacaoAlmoxarife = ref({
      authType: "",
      authContent: "",
    });
    const crachaSolicitante = ref(null);
    const usuarioEncontradoPorCracha = ref(null);
    const atualizarUserLogado = ref(0);
    const checklist = ref([]);
    const acessorios = ref([]);
    const listaSelecionados = ref([]);
    let rightDrawerOpen = ref(false);
    const respostas = ref({ responderCheckLists: "", responderAcessorios: "" });
    const validarRespostas = ref(0);
    let mobile = ref(false);

    if (quasar.platform.is.mobile) {
      mobile.value = true;
    }

    const listarFerramentaRetiradaBloqueados = async (
      page = 1,
      rowsNumber = 15,
      ordenacao = { nome: "desc" }
    ) => {
      if (
        dados.value.dadosRequisitante.id === "" ||
        dados.value.dadosRequisitante.id === undefined
      ) {
        listaFerramenta.value = [];
        return;
      }
      confirm.value = false;
      mensagemAtrasado.value = false;
      const responseAtrasado = await store.dispatch(
        "ferramentaria/ativoAtrasado",
        {
          unidadeId: store.state.org.unidadeData.id,
          funcionarioId: dados.value.dadosRequisitante.matricula,
        }
      );
      if (responseAtrasado.data.resultado.dados.length != 0) {
        mensagemAtrasado.value = true;
        listaAtrasado.value = [];
        listaAtrasado.value = responseAtrasado.data.resultado.dados;

        if (!avisoAtrasadoJaExibido.value) {
          confirm.value = true;
          avisoAtrasadoJaExibido.value = true;
        }
      }

      loading.value = true;
      disable.value = true;
      try {
        const response = await store.dispatch(
          "ferramentaria/listarAtivoBloqueado",
          {
            ordenacao: ordenacao,
            unidadeId: store.state.org.unidadeData.id,
            perPage: rowsNumber,
            page: page,
            status: "disponivel",
            comCheckLists: "sim",
            comAtributos: "sim",
            funcionarioId: dados.value.dadosRequisitante.matricula,
            comAcessorios: "sim",
            codigo: filtros.value?.codigo,
            nome: filtros.value?.descricao,
            patrimonio: filtros.value.patrimonio,
            nomeGrupo: filtros.value?.grupo?.nome,
            nomeSubgrupo: filtros.value?.grupo?.nome
              ? filtros.value?.subgrupo?.nome
              : "",
          }
        );
        listaFerramenta.value = response.listaAtivo;

        pagination.value.page = response.response.data.resultado.currentPage;
        pagination.value.rowsPerPage = response.response.data.resultado.perPage;
        pagination.value.rowsNumber = response.response.data.resultado.total;
        loading.value = false;
        disable.value = false;
        verificarDocumentosVencidos();
      } catch (error) {
        console.log(error);
        loading.value = false;
        disable.value = false;
      }
    };

    const receberFuncionario = async (value) => {
      if (processandoSelecaoFuncionario.value) {
        return;
      }

      processandoSelecaoFuncionario.value = true;

      try {
        const funcionarioAnterior = dados.value.dadosRequisitante.id;

        if (value === null || value === undefined) {
          dados.value.dadosRequisitante = {
            id: "",
            nome: "",
            matricula: "",
            biometria: "",
            idTabela: "",
          };
          if (funcionarioAnterior !== "") {
            avisoAtrasadoJaExibido.value = false;
          }
          return;
        }

        if (funcionarioAnterior !== value.id) {
          avisoAtrasadoJaExibido.value = false;
        }

        dados.value.dadosRequisitante = {
          id: value.id,
          nome: value.nome,
          matricula: value.matricula,
          biometria: value.biometria,
          idTabela: value.idTabela,
        };
      } finally {
        setTimeout(() => {
          processandoSelecaoFuncionario.value = false;
        }, 3000);
      }
    };

    const removerFerramenta = (ativoUuid) => {
      selected.value = selected.value.filter(
        (ferramenta) => ferramenta.ativoUuid != ativoUuid
      );
    };

    const verificarRespostas = () => {
      validarRespostas.value++;
    };

    const criarRetirada = () => {
      if (dados.value.dadosRequisitante?.id === "") {
        quasar.notify({
          message: "Selecione um requisitante.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (selected.value.length === 0) {
        quasar.notify({
          message: "Selecione ao menos uma ferramenta.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      quasar.notify({
        message: "Retirada criada.",
        color: "positive",
        actions: [
          {
            label: "Fechar",
            color: "white",
            handler: () => {
              /* ... */
            },
          },
        ],
      });
      autenticacao.value = true;
    };

    const atualizarTemplatesBiometria = async () => {
      try {
        await store.dispatch("user/atualizarTemplatesBiometria");
        atualizarDadosUsuario.value++;
        atualizarUserLogado.value++;
      } catch (error) {
        console.log(error);
      }
    };

    const resetVariaveis = () => {
      selected.value = [];
      autenticacao.value = false;
      dados.value.metodoAutenticacao = "semAutenticacao";
      base64.value = null;
      usuarioVerificado.value = false;
      autenticacaoSolicitante.value = {
        authType: "",
        authContent: "",
      };
      autenticacaoAlmoxarife.value = {
        authType: "",
        authContent: "",
      };
    };

    const retirarFerramenta = async (observacao) => {
      disable.value = true;
      desabilitarBotaoCriar.value = true;
      try {
        let ativos = [];
        selected.value.forEach((ativo) => {
          ativos.push({
            ativoUuid: ativo.ativoUuid,
            checkLists:
              ativo?.checkLists?.length > 0
                ? verificarChecklist(ativo?.checkLists)
                : undefined,
            acessorios:
              ativo?.acessorios?.length > 0
                ? verificarAcessorio(ativo?.acessorios)
                : undefined,
          });
        });
        await store.dispatch("ferramentaria/criarEmprestimo", {
          unidadeId: store.state.org.unidadeData.id,
          reservaUuid: "",
          almoxId: store.state.autenticacao.usuarioLogado.id,
          solicitanteId: dados.value.dadosRequisitante.id,
          solicitanteAuthType: autenticacaoSolicitante.value.authType,
          solicitanteAuthContent: autenticacaoSolicitante.value.authContent,
          almoxAuthType: autenticacaoAlmoxarife.value.authType,
          almoxAuthContent: autenticacaoAlmoxarife.value.authContent,
          solicitanteNome: dados.value.dadosRequisitante.nome,
          almoxNome: store.state.autenticacao.usuarioLogado.nome,
          comentarioRetirada: observacao?.replace(new RegExp("\\n", "gi"), " "),
          ativos: ativos,
        });
        quasar.notify({
          message: "Retirada feita com sucesso.",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        resetVariaveis();
        resetarFuncionario.value++;
        resetarAutenticacao.value++;
        listaFerramenta.value = [];
        desabilitarBotaoCriar.value = false;
      } catch (error) {
        desabilitarBotaoCriar.value = false;
        if (error.response?.data.erro?.detalhes?.ativos?.checkLists) {
          quasar.notify({
            message: "Responda todos os checklists.",
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
        if (error.response?.data.erro?.mensagem) {
          quasar.notify({
            message: error.response?.data.erro?.mensagem,
            color: "negative",
            actions: [
              {
                label: "Fechar",
                color: "white",
                handler: () => {
                  /* ... */
                },
              },
            ],
          });
        }
      }
    };

    const verificarDocumentosVencidos = () => {
      listaFerramenta.value.forEach((ativo) => {
        if (ativo.documentosVinculados.length > 0) {
          ativo.documentosVinculados.forEach((documento) => {
            if (documento.status == "vencido" && ativo.vencido == undefined) {
              ativo.vencido = true;
            }
          });
        }
      });
    };

    const receberAutenticacaoSolicitante = (value) => {
      autenticacaoSolicitante.value = value;
    };

    const receberFiltro = (value) => {
      filtros.value = value;
      listarFerramentaRetiradaBloqueados();
    };

    const verificarChecklist = (checklist) => {
      let valido = checklist.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      checklist.forEach((value) => {
        array.push({
          checkListUuid: value.checkListUuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const verificarAcessorio = (acessorios) => {
      let valido = acessorios.every(
        (value) => value.resposta === "sim" || value.resposta === "nao"
      );
      if (!valido) {
        return undefined;
      }
      let array = [];
      acessorios.forEach((value) => {
        array.push({
          acessorioUuid: value.uuid,
          resposta: value.resposta,
        });
      });
      return array;
    };

    const receberAutenticacaoAlmoxarife = (value) => {
      autenticacaoAlmoxarife.value = value;
    };

    const receberSetupConfiguracao = (value) => {
      respostas.value = value;
    };

    const filtrarSelecionados = () => {
      listaSelecionados.value = selected.value.filter(
        (ativo) =>
          ativo?.catalogoItem?.codigo
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase()) ||
          ativo?.catalogoItem?.nome
            .toLowerCase()
            .includes(filtroSelecionado.value.toLowerCase())
      );
    };

    const receberFuncionarioPorCracha = (value) => {
      if (value === "" || value === null || value === undefined) {
        return;
      }

      const funcionarioFormatado = {
        id: value.id,
        nome: value.nome,
        matricula: value.matricula,
        biometria: value.biometria,
        idTabela: value.idTabela,
      };

      receberFuncionario(funcionarioFormatado);
    };

    const buscarPorCracha = async (card_id) => {
      if (!card_id || card_id.trim() === "") {
        usuarioEncontradoPorCracha.value = null;
        return;
      }

      try {
        const response = await store.dispatch("fer/listarFuncionarios", {
          card_id: card_id,
          vendor_id: store.state.org.unidadeData.id,
        });

        if (response.data?.results?.data?.length > 0) {
          const usuario = response.data.results.data[0];
          usuarioEncontradoPorCracha.value = usuario;

          const funcionarioFormatado = {
            id: usuario.sap,
            idTabela: usuario.id,
            nome: usuario.name,
            matricula: usuario.sap,
            centroCustoCode: usuario.cost_center?.code,
            centroCustoName: usuario.cost_center?.name,
            biometria: usuario.biometry,
          };

          receberFuncionarioPorCracha(funcionarioFormatado);
        } else {
          usuarioEncontradoPorCracha.value = null;
        }
      } catch (error) {
        console.error("Erro ao buscar usuário por crachá:", error);
        usuarioEncontradoPorCracha.value = null;
      }
    };

    const temPermissaoCracha = () => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "voucher-auth-cracha"
        ) || false
      );
    };

    watch(
      () => dados.value.dadosRequisitante.id,
      () => {
        resetVariaveis();

        listarFerramentaRetiradaBloqueados();
        resetarAutenticacao.value++;
      }
    );

    watch(
      () => dados.value.metodoAutenticacao,
      () => {
        usuarioVerificado.value = false;
        base64.value = null;
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        dados.value.dadosRequisitante = {
          id: "",
          nome: "",
          matricula: "",
          biometria: "",
        };
        resetarFuncionario.value++;
        resetVariaveis();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarFerramentaRetiradaBloqueados(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => filtroSelecionado.value,
      () => {
        filtrarSelecionados();
      }
    );

    watch(
      () => selected.value,
      () => {
        filtroSelecionado.value = "";
        listaSelecionados.value = [...selected.value];
      }
    );

    onMounted(() => {
      listarFerramentaRetiradaBloqueados();
    });

    const handleRequest = async (value) => {
      const ordenacao = {};

      if (valorOrdenacao.value == value.pagination.sortBy) {
        igual.value = !igual.value;
        ordenacao[
          valorOrdenacao.value == "descrição" ? "nome" : valorOrdenacao.value
        ] = igual.value ? "asc" : "desc";

        pagination.value.sortBy = valorOrdenacao.value;
        pagination.value.descending = igual.value ? false : true;

        listarFerramentaRetiradaBloqueados(
          pagination.value.page,
          pagination.value.rowsPerPage,
          ordenacao
        );
        return;
      }

      igual.value = false;

      valorOrdenacao.value = value.pagination.sortBy;
      pagination.value.sortBy = valorOrdenacao.value;
      pagination.value.descending = true;

      ordenacao[
        valorOrdenacao.value == "descrição" ? "nome" : valorOrdenacao.value
      ] = "desc";

      listarFerramentaRetiradaBloqueados(
        pagination.value.page,
        pagination.value.rowsPerPage,
        ordenacao
      );
    };

    return {
      columns,
      columns2,
      receberFuncionario,
      receberFuncionarioPorCracha,
      buscarPorCracha,
      temPermissaoCracha,
      crachaSolicitante,
      usuarioEncontradoPorCracha,
      handleRequest,
      listaFerramenta,
      dados,
      selected,
      removerFerramenta,
      criarRetirada,
      autenticacao,
      quasar,
      resetVariaveis,
      listaSelecionados,
      base64,
      atualizarUserLogado,
      retirarFerramenta,
      salvarAssinatura,
      verificarDocumentosVencidos,
      biometriaModal,
      atualizarTemplatesBiometria,
      atualizarDadosUsuario,
      resetarFuncionario,
      receberAutenticacaoSolicitante,
      receberAutenticacaoAlmoxarife,
      usuarioVerificado,
      disable,
      dadosReserva,
      verificarChecklist,
      ativosSelecionadoReserva,
      loading,
      filtros,
      mobile,
      fazerAutenticacao,
      pagination,
      resetarAutenticacao,
      autenticacaoSolicitante,
      autenticacaoAlmoxarife,
      receberSetupConfiguracao,
      filtroSelecionado,
      checklist,
      acessorios,
      respostas,
      desabilitarBotaoCriar,
      rightDrawerOpen,
      verificarAcessorio,
      mensagemAtrasado,
      validarRespostas,
      verificarRespostas,
      columnsModal,
      receberFiltro,
      confirm,
      listaAtrasado,
      pageTitle,
      backRouteConfig,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}

thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:first-child th {
  top: 0;
}

.q-table--loading thead tr:last-child th {
  top: 48px;
}
.my-sticky-dynamic {
  max-height: 400px;
}
thead tr th {
  position: sticky;
  z-index: 1;
}
thead tr:last-child th {
  top: 48px;
}
thead tr:first-child th {
  top: 0;
}
tbody tr td {
  white-space: pre-wrap;
}
tbody tr .coluna-selecionar {
  width: 40px !important;
  margin: 0px;
  padding: 3px 2px;
}
tbody tr .coluna-atributo {
  width: 250px !important;
}
.imagem-biometria {
  height: 80px;
  width: 80px;
  cursor: pointer;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.icon-texto {
  font-size: 25px;
}
.texto-titulo {
  font-size: 20px;
}
.titulo-tabela {
  font-size: 18px;
}
.texto-checklist {
  width: 80px;
}
.titulo-item-texto {
  font-size: 18px;
}
.subtitulo-item-texto {
  font-size: 16px;
  font-weight: bold;
}
.titulo-pergunta-item-texto {
  font-size: 15px;
  word-wrap: break-word;
  word-break: break-all;
}
.borda-top {
  border-top: 2px solid #707070;
}
.borda-bottom {
  border-bottom: 2px solid #707070;
}
.mobile {
  display: none;
}
.img {
  width: 60px;
  height: 60px;
}
.container-grid-table {
  border: 1px solid #707070;
  font-size: 12px;
}
.elipse-table {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 16px;
  }
  .icon-texto {
    font-size: 20px;
    margin-right: 1px;
  }
  .texto-titulo-reserva {
    font-size: 16px;
  }
  .container-link-voltar {
    margin-right: 10px;
  }
  .titulo-input {
    font-size: 12px;
  }
  .input {
    font-size: 12px;
  }
  .titulo-tabela {
    font-size: 14px;
    margin-bottom: 10px;
    margin-left: 0px;
  }
  .container-selecao-autenticacao {
    margin: 10px 0px 0px 0px;
  }
  .container-autenticacao-pin {
    margin: 15px 0px 0px 0px;
  }
  .container-autenticacao-assinatura {
    margin: 15px 0px 0px 0px;
  }
  .btn {
    font-size: 13px;
    margin-bottom: 19px;
  }
  .elipse-mobile {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    margin: 5px 0px 10px 0px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .titulo-item-texto {
    font-size: 14px;
  }
  .subtitulo-item-texto {
    font-size: 13px;
  }
  .titulo-pergunta-item-texto {
    font-size: 12px;
    word-break: break-all;
  }
  .radio {
    font-size: 12px;
  }
  .img {
    width: 50px;
    height: 50px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}
</style>
